<template>
  <h1>Exemplo 3</h1>
</template>

<script>
export default {
  name: "Exemplo3"
};
</script>
